import React, { FunctionComponent, useEffect, useState } from 'react';
import ArticleMeta from '../../components/article-meta/ArticleMeta';
import { getArticleById } from '../../articles/services/ArticleService';

interface ArticleRecommendationCardProps {
  id: string;
  title: string;
  authorName: string;
  authorLink?: string;
  tagLabel: string;
  categoryLink?: string;
  publishDate: string;
  readTime: string;
  cardSize: string;
  imageLink: string;
  link: string;
  isAdslot: boolean;
  position?: number; // for clicker v2
}

const ArticleRecommendationCard: FunctionComponent<ArticleRecommendationCardProps> = ({
  id,
  title,
  tagLabel,
  publishDate,
  readTime,
  cardSize,
  imageLink,
  link,
  categoryLink,
  isAdslot,
  position,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [fixedTitle, setFixedTitle] = useState(title);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const cardClassName = `react-article-card react-article-card--${cardSize}`;
  const adContainerId = `native-ad-container${cardSize === 'medium' ? '-secondary' : ''}`;
  const adContainer = isAdslot ? <div className="related-posts__native-ad" id={adContainerId}></div> : '';

  // Add position as parameter to the link for clicker (recommendation only)
  const addParamsToLink = (originalLink: string) => {
    if (tagLabel === 'Native Ad') {
      return originalLink;
    }

    const url = new URL(originalLink);
    const utm_medium = 'Recommendation';

    // Only add position from the card
    if (position) {
      url.searchParams.append('utm_position', position.toString());
      url.searchParams.append('utm_medium', utm_medium);
    }

    return url.toString();
  };

  const linkWithParams = addParamsToLink(link);

  useEffect(() => {
    if (!title) {
      getArticleById(id, ['title'])
        .then(({ title }) => setFixedTitle(title))
        .catch(console.error);
    }
  }, [id, title]);

  return (
    <React.Fragment>
      {adContainer}
      <div className={cardClassName}>
        <div
          className="react-article-card__image-wrapper"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <a href={linkWithParams} className="react-article-card__image">
            <img loading="lazy" src={imageLink} alt={fixedTitle} />
          </a>

          <div className="article-card__tag-wrapper article-card__tag-wrapper--image">
            <a href={categoryLink ?? '#'} className="tag-link">
              <div className="tag tag--link tag--background">
                <div className="tag__text">{tagLabel}</div>
              </div>
            </a>
          </div>
        </div>

        <div className="react-article-card__content-wrapper">
          <div
            className="react-article-card__title-wrapper"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <a href={linkWithParams} className={`react-article-card__title-link ${isHovered ? 'hovered' : ''}`}>
              {cardSize === 'large' ? (
                <h4 className="react-article-card__title heading h4-noto">{fixedTitle}</h4>
              ) : (
                <h6 className="react-article-card__title heading h6-noto">{fixedTitle}</h6>
              )}
            </a>
          </div>

          <ArticleMeta
            articleData={{
              id: id,
              title: fixedTitle,
              url: linkWithParams,
              image: imageLink,
              publishDate: publishDate,
              readTime: readTime,
              isPremium: false,
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ArticleRecommendationCard;
